import React from "react"

import VScroll from "../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import {AddView_OptionConfig, AddView_Group} from "../@types"

type Props = {
    selectedGroup   : AddView_Group

    onSelect        : {(item:AddView_OptionConfig):void}
    hidePopover     : func
}

// const debug = "NavigationMenuAddViewRight"
const debug = false

export default function NavigationMenuAddViewRight(props:Props) {

    const upgrade = (item:AddView_OptionConfig) => {
        debug && console.log(debug, 'upgrade')
        props.hidePopover()
        gd.modals.other.upgrade(item.proFeature)
    }

    const select = (item:AddView_OptionConfig) => {
        debug && console.log(debug, 'select')
        props.onSelect(item)
    }

    const views : AddView_OptionConfig[] = _.compact(props.selectedGroup.items)

    return (
        <div className="right flex-column-left-top">
            <VScroll containerClass="p-t-15">
                {_.map(views, (item: AddView_OptionConfig, key: number)=>(

                    <div key={'{0}_{1}'.f(item.typeId, key)} className="view-item" onClick={item.isPro ? ()=>upgrade(item) : ()=>select(item)}>
                        <div className={Classes("w-30 h-30 m-r-10 flex-no-shrink", item.iconSvg)}/>
                        <div className="view-item-info">
                            <div className="flex-row-center-space-between w-100-percent">
                                <div className="title ui5-txt-less-important-small lh-20 txt-truncate">
                                    {item.title}
                                </div>

                                {/*{item.alreadyExists &&*/}
                                {/*    <div className="ui5-status-list status-c0 s18 m-l-10 flex-no-shrink">Added</div>}*/}

                                {item.alreadyExists &&
                                    <div className="flex-row-left-center p-r-10">
                                        <div className="m-r-3 flex-no-shrink i5-checkbox-ok ui5-ico-12 ui5-color-green fs-10" />
                                        <div className="ui5-txt-not-important-tiny ui5-color-green">Added</div>
                                    </div>}

                            </div>

                            <div className="description ui5-txt-not-important-tiny lh-20 txt-truncate">
                                {item.description}
                            </div>
                        </div>
                    </div>
                ))}
            </VScroll>
        </div>
    )
}